<template lang="pug">
#add-bank.tab-pane.fade.show.active
  //- ul.nav.nav-tabs(role='tablist')
  //-   li.nav-item(role='presentation' @click="changeTab(0)")
  //-     button#ewallet.nav-link(:class="{'active' : selectedTab === 0}" data-bs-toggle='tab' data-bs-target='#ewallet' type='button' role='tab' aria-controls='ewallet' aria-selected='true') {{$t('ui.bank_ewallet')}}
  //-   li.nav-item(role='presentation' @click="changeTab(1)")
  //-     button#banks.nav-link(:class="{'active' : selectedTab === 1}" data-bs-toggle='tab' data-bs-target='#banks' type='button' role='tab' aria-controls='banks' aria-selected='false') {{$t('ui.bank')}}
  div(style="padding:20px 20px 0 20px")
    .row.bank-select-wrap.mx-0
      label.col-6.bank-wrap.bank-tap.py-2.button-radio(:class="[{'selected-option' : method === 'ewallet'}]")
        input(type="radio" name="radio" value="ewallet"  v-model="method")
        i.fa-solid.fa-wallet 
        span &nbsp;{{$t('ui.bank_ewallet')}}
        .checked-selected(v-if="method === 'ewallet'")
          i.fa-solid.fa-check
      label.col-6.bank-wrap.bank-tap.py-2.button-radio(:class="[{'selected-option' : method === 'bank'}]" )
        input(type="radio" name="radio" value="bank" v-model="method")
        i.fas.fa-landmark
        span &nbsp;{{$t('ui.bank')}}
        .checked-selected(v-if="method === 'bank'")
          i.fa-solid.fa-check
  .tab-content.p-0
    ewallet(v-if="method==='ewallet'" :dropdownList="ewalletList" :activeList="eActivelist")
    bank(v-if="method==='bank'" :dropdownList="bankList" :activeList="bActivelist")
</template>
<script>
import ewallet from '@/component/bank/_ewallet.vue'
import bank from '@/component/bank/_bank.vue'
export default {
  components:{
    ewallet,
    bank
  },
  data(){
		return{
			selectedTab: 0,
      showEwallet: true,
      bankList: [],
      ewalletList: [],
      method: "ewallet",
      eActivelist: [],
      bActivelist: [],
		}		
	},
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getBankListing() {
      return this.$store.getters.bankList
    },
  },
  created(){
    this.getActiveList()
  },
  mounted(){
    if(this.$store.getters.isLoggedIn){
      this.getBankList()
    }
  },
  methods:{
		changeTab(option){
			if(option === this.selectedTab){
				return;
			}else{
				this.selectedTab = option
			}
		},
    getBankList() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/bankLookUp", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data) {
                if(response.data.length > 0) {
                  response.data.forEach(y => {
                    if(y.category==='BANK'){
                      this.bankList.push(y)
                    }else if(y.category === 'EWALLET'){
                      this.ewalletList.push(y)
                    }
                    
                  })
                }
              }
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this)
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this)
            }
          })
      }
    },
    getActiveList(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/activeList", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
							response.data.forEach(y => {
                if(y.category==='BANK'){
                  this.bActivelist.push(y)
                }else if(y.category === 'EWALLET'){
                  this.eActivelist.push(y)
                }
                
              })
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    }
	}
}
</script>
<style lang="scss" scoped>
.resbox-tabs .tab-content .tab-pane{
  // background-color: transparent
}
</style>